/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import {
  httpClient, BASE_URL, PORTS, SERVICES, PATH_EXTENSION,
} from '@/middlewares/httpClient';
import { API, Endpoint } from './models';

const key: string = 'flowmanager';
const port: string = PORTS.get(key);
const service: string = SERVICES.get(key);

const FLOW_MANAGER: string = `${BASE_URL}:${port}${PATH_EXTENSION}/${service}`;

// APIs
const GetAPIs = (workspaceId: string) => httpClient.get(`${FLOW_MANAGER}/workspaces/${workspaceId}/apis`);

const AddAPI = (workspaceId: string, api: API) => httpClient.post(`${FLOW_MANAGER}/workspaces/${workspaceId}/apis`, api);

const EditAPI = (workspaceId: string, api: API) => httpClient.put(`${FLOW_MANAGER}/workspaces/${workspaceId}/apis`, api);

const DeleteApi = (workspaceId: string, apiId: string) => httpClient.delete(`${FLOW_MANAGER}/workspaces/${workspaceId}/apis/${apiId}`);

// APIs - ENDPOINTS
const AddEndpoint = (workspaceId: string, apiId: string, endpoint: Endpoint) => httpClient.post(`${FLOW_MANAGER}/workspaces/${workspaceId}/apis/${apiId}/endpoints`, endpoint);

const EditEndpoint = (workspaceId: string, apiId: string, endpoint: Endpoint) => httpClient.put(`${FLOW_MANAGER}/workspaces/${workspaceId}/apis/${apiId}/endpoints`, endpoint);

const DeleteEndpoint = (workspaceId: string, apiId: string, endpointId: string) => httpClient.delete(`${FLOW_MANAGER}/workspaces/${workspaceId}/apis/${apiId}/endpoints/${endpointId}`);

export {
  AddAPI, GetAPIs, DeleteApi, EditAPI,
  AddEndpoint, EditEndpoint, DeleteEndpoint,
};
